import React, { useRef } from 'react'
import { useStateValue } from '@State'

export const CertImage = () => {
  const [state, dispatch] = useStateValue()
  const imageInput = useRef(null)

  const handleChange = () => {
    const newImage = imageInput.current.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(newImage)
    reader.onload = e => {
      dispatch({
        type: 'UPDATE_CERT_INFO',
        payload: {
          image: e.target.result,
          imageName: newImage.name,
          imageLoaded: true,
          newUploadedImage: true,
        },
      })
    }
  }

  return (
    <div className="image_info">
      <input
        type="file"
        id="image_input"
        accept=".png, .jpeg, .jpg"
        ref={imageInput}
        onChange={handleChange}
      />
      <p>{state.certInfo.imageName}</p>
    </div>
  )
}
